<template>
  <div>
    <div
      class="c-requestContentsMenuPcFixedAdjust"
      v-if="isFixedMenu"
    ></div>
    <div
      class="c-requestContentsMenuPc"
      :class="{ 'c-requestContentsMenuPc-fixed' : isFixedMenu }"
      v-scroll="handleScroll"
    >
      <div class="c-requestContentsMenuPc_items">
        <div class="c-requestContentsMenuPc_item">
          <a
            href="#"
            v-scroll-to="{ el: '#requestContentsSummary', offset: scrollToOffset }"
            :class="{ '-active': isActive.summary }"
            v-if="requestDetail.summariesList.length"
          >
            <div>依頼概要</div>
          </a>
        </div>
        <div class="c-requestContentsMenuPc_item">
          <a
            href="#"
            v-scroll-to="{ el: '#requestContentsDetail', offset: scrollToOffset }"
            :class="{ '-active': isActive.detail }"
          >
            <div>依頼内容の詳細</div>
          </a>
        </div>
        <div
          class="c-requestContentsMenuPc_item"
          v-if="!isBusiness || isMyRequest"
        >
          <a
            href="#"
            v-scroll-to="{ el: '#requestContentsFaq', offset: scrollToOffset }"
            :class="{ '-active': isActive.faq }"
          >
            <div>依頼内容についての質問</div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
const FOOTER_MARGIN_TOP = 112

// vuex
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'ContentsMenuPc',
  props: {
    position: {
      type: Number,
      default: 0
    },
    scrollToOffset: {
      type: Number,
      default: 0
    },
    isMyRequest: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      elRectY: 0,
      footerRectY: 0,
      activeMenu: 'summary',
      // activeの判定のためDOMの逆順で記載する
      isActive: {
        faq: false,
        detail: false,
        summary: true
      }
    }
  },
  created() {
    if (!this.requestDetail.summariesList.length) {
      // 依頼概要がないとき
      delete this.isActive.summary
      this.isActive.detail = true
    }
  },
  mounted() {
    const elRect = this.$el.getBoundingClientRect().top
    const scrollY = window.scrollY || window.pageYOffset
    this.elRectY = elRect + scrollY
  },
  computed: {
    ...mapGetters('ui', ['isPC']),
    ...mapState('constants', ['HEADER_HEIGHT']),
    ...mapState('pages/requests/request', ['requestDetail']),
    ...mapState('auth/user', ['isBusiness']),
    isFixedMenu() {
      return (
        this.elRectY &&
        this.position >= this.elRectY - this.HEADER_HEIGHT.DEFAULT &&
        this.footerRectY - FOOTER_MARGIN_TOP > this.position
      )
    }
  },
  methods: {
    handleScroll() {
      let active = false
      const menuList = Object.keys(this.isActive)
      const scrollY = window.scrollY || window.pageYOffset
      menuList.forEach(menu => {
        let rect = null
        const el = document.querySelector(`.js-contentsMenu-${menu}`)
        // 各メニューの開始座標の計算: ブラウザからの座標 + スクロール量 + オフセット量
        // 開閉コンテンツがあることやメニューが可変なためスクロール毎に計算している
        if (el) {
          rect = Math.floor(el.getBoundingClientRect().top) + scrollY + this.scrollToOffset
        }

        // 現在のスクロール量をメニューのページ下からチェックしていき開始座標を超えたらアクティブを立てる
        if (rect && scrollY >= rect && !active) {
          this.isActive[menu] = true
          active = true
        } else {
          this.isActive[menu] = false
        }
      })

      // アクティブがなかった場合（ページ開始から最初のメニューまで）最初のメニューをアクティブにする
      if (!active) {
        this.isActive[menuList.slice(-1)[0]] = true
      }

      // footerの座標取得
      const footer = document.querySelector('.js-the-footer')
      if (footer) {
        const footerRect = footer.getBoundingClientRect().top
        this.footerRectY = footerRect + scrollY - this.HEADER_HEIGHT.DEFAULT
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.c-requestContentsMenuPcFixedAdjust {
  height: 52px;
}

.c-requestContentsMenuPc {
  margin-bottom: 12px;
  padding-top: 4px;
  height: 52px;
  background: $color-white;
  box-shadow: inset 0 -1px 0 0 $color-gray-200;
  font-size: 15px;

  &-fixed {
    position: fixed;
    top: 100px;
    z-index: z(sub-header, main);
    margin-bottom: 0;
    width: 690px;
  }

  &_items {
    display: flex;
    width: 690px;
  }

  &_item {
    align-self: center;

    a {
      display: flex;
      overflow: hidden;
      padding: 0 12px 4px;
      height: 48px;
      color: $color-gray-600;

      align-items: center;
      justify-content: center;

      &.-active {
        padding-bottom: 0;
        border-bottom: 4px solid $color-blue-500;
        color: $color-gray-800;
        font-weight: bold;
      }

      &:hover {
        @include link-effect;
      }
    }
  }
}
</style>
